<template>
  <div>
    <div class="nav-box">
      <div class="item" :class="{active:nav == 0}" @click="selectNav(0)">概括</div>
      <div class="item" :class="{active:nav == 1}" @click="selectNav(1)">明细</div>
    </div>
    <a-row :gutter="60" v-if="nav == 0">
      <a-col :span="12">
        <div class="item-title">
          <div class="left">年度收益</div>
          
          <div class="right">
            <a-select style="width:90px" size="small" v-model="commission.year" dropdown-class-name="durk" @change="changeYear('commission')">
              <a-select-option :value="item" v-for="(item, index) in commission.years" :key='index'>{{item}}年</a-select-option>
            </a-select>
          </div>
          
        </div>
        
        <div class="count-box">
          <div class="value"><span class="small">￥</span>{{commission.yearValue}}</div>
          <div class="label">{{commission.year}}年总收益</div>
        </div>
       
      </a-col>
      <a-col :span="12">
        <div class="item-title">
          <div class="left">月度收益</div>
          <div class="right">
            <a-select style="width:110px" size="small" v-model="commission.month" dropdown-class-name="durk" @change="getMonthCommission">
              <a-select-option :value="commission.year + '-' + item" v-for="(item, index) in commission.months" :key='index'>{{commission.year}}-{{item}}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="count-box">
          <div class="value"><span class="small">￥</span>{{commission.monthValue}}</div>
          <div class="label">{{commission.month}}总收益</div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="item-title">
          <div class="left">年度点击</div>
          <div class="right">
            <a-select style="width:110px" size="small" v-model="click.year" dropdown-class-name="durk" @change="changeYear('click')">
              <a-select-option :value="item" v-for="(item, index) in click.years" :key='index'>{{item}}年</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="count-box">
          <div class="value">{{click.yearValue}}<span class="small">次</span></div>
          <div class="label">{{click.year}}年总点击量</div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="item-title">
          <div class="left">月度点击</div>
          <div class="right">
            <a-select style="width:110px" size="small" v-model="click.month" dropdown-class-name="durk" @change="getMonthClick">
              <a-select-option :value="click.year + '-' + item" v-for="(item, index) in click.months" :key='index'>{{click.year}}-{{item}}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="count-box">
          <div class="value">{{click.monthValue}}<span class="small">次</span></div>
          <div class="label">{{click.month}}总点击量</div>
        </div>
      </a-col>
    </a-row>

    <a-row :gutter="60" class="logs-box" v-if="nav ==1">
      <a-col :span="24">
        <div class="item-title">收益明细</div>
        <a-table :columns="commissionColumns" :data-source="commission.logs.data" size="middle" row-key="url" :pagination="false" class="transpanret-table">
          <span slot="from" slot-scope="record">
            <span v-if="record.from_uid">
              推广者[{{record.from_uid}}]
            </span>
            <span v-else>
              用户订单[{{record.product_desc}}]
            </span>
          </span>
        </a-table>
        <div class="page-box">
          <a-pagination :total="commission.logs.total" v-model="commission.page" @change="getCommissionLogs" :page-size="10" size="small" />
        </div>
      </a-col>
      <a-col :span="12">
        <div class="item-title">每日收益</div>
        <a-table :columns="commissionDateColumns" :data-source="commission.dateLogs.data" size="middle" row-key="date" :pagination="false" class="transpanret-table"></a-table>
        <div class="page-box">
          <a-pagination :total="commission.dateLogs.total" v-model="commission.datePage" @change="getCommissionDateLogs" :page-size="10" size="small" />
        </div>
      </a-col>
      <a-col :span="12">
        <div class="item-title">每日点击量</div>
        <a-table :columns="columns" :data-source="click.logs.data" size="middle" row-key="date" :pagination="false" class="transpanret-table"></a-table>
        <div class="page-box">
          <a-pagination :total="click.logs.total" v-model="click.page" @change="getClickLogs" :page-size="10" size="small" />
        </div>
      </a-col>
      
      <a-col :span="24">
        <div class="item-title">链接点击量</div>
        <a-table :columns="linkColumns" :data-source="linkLogs.data" size="middle" row-key="url" :pagination="false" class="transpanret-table"></a-table>
        <div class="page-box">
          <a-pagination :total="linkLogs.total" v-model="linkPage" @change="getLinkLogs" :page-size="10" size="small" />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
const columns = [
  {
    title: '日期',
    dataIndex:'date'
  },
  {
    title: '点击数量',
    dataIndex:'count'
  },
];
const commissionDateColumns = [
  {
    title: '日期',
    dataIndex:'date'
  },
  {
    title: '订单数量',
    dataIndex:'count'
  },
  {
    title: '收益',
    dataIndex:'commission'
  }
];
const commissionColumns = [
  {
    title: '日期',
    dataIndex:'created_at'
  },
  {
    title: '来自',
    scopedSlots: { customRender: 'from' },
  },
  {
    title: '备注',
    dataIndex:'remark'
  },
  {
    title: '收益',
    dataIndex:'commission'
  }
];
const linkColumns = [
  {
    title: '链接',
    dataIndex:'url'
  },
  {
    title: '点击数量',
    dataIndex:'count'
  }
];
let self;
export default {
  name: '',
  data(){
    return {
      columns,
      commissionDateColumns,
      commissionColumns,
      linkColumns,
      commission:{
        years:[],
        months:[],
        year:'',
        month:'',
        yearValue:0,
        monthValue:0,
        monthInfo:0,
        dateLogs:{},
        datePage:1,
        logs:{},
        page:1
      },
      click:{
        years:[],
        months:[],
        year:'',
        month:'',
        yearValue:0,
        monthValue:0,
        logs:{},
        page:1
      },
      linkLogs:{},
      linkPage:1,
      nav:0,
    }
  },
  mounted(){
    self = this;
    this.initYears();
    this.selectNav(0)
  },
  methods:{
    initYears(){
      let date = new Date();
      let year = date.getFullYear();
      //过去3年
      let years = [year];
      for(let i = 1 ; i<=3; i++){
        years.push(year-i);
      }

      this.commission.years = years;
      this.commission.year = year;
      
       this.click.years = years;
      this.click.year = year;

      this.initMonth(year, 'commission');
      this.initMonth(year, 'click');
    },
    initMonth(selectedYear, type){
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth()+1;

      //如果选择的不是今年设置12个月
      if(selectedYear != year){
        month = 12;  
      }
      let months = [];
      for(let i = 1; i <= month; i++){
        let m = i.toString();
        months.push(m.length == 1 ? '0'+m : m);
      }
      if(type == 'commission'){
        this.commission.months = months;
        this.commission.month = this.commission.year + '-' + month;
      }else{
        this.click.months = months;
        this.click.month = this.click.year + '-' + month;
      }
    },
    changeYear(type){
      this.initMonth(this.commission.year, type);
      if(type == 'commission'){
        this.getYearCommission();
        this.getMonthCommission();
      }else{
        this.getYearClick();
        this.getMonthClick();
      }
    },
    getYearCommission(){
      this.$http.get('yearCommission',{params:{year:this.commission.year}}).then((res)=>{
        self.commission.yearValue = res.data;
      }).finally(()=>{
       
      });
    },
    getMonthCommission(){
      this.$http.get('monthCommission',{params:{month:this.commission.month}}).then((res)=>{
        self.commission.monthValue = res.data;
      });
    },
    getCommissionDateLogs(){
      this.$http.get('listCommissionDateLogs',{params:{page:this.commission.datePage}}).then((res)=>{
        self.commission.dateLogs = res.data;
      });
    },
    getCommissionLogs(){
      this.$http.get('listCommissionLogs',{params:{page:this.commission.page}}).then((res)=>{
        self.commission.logs = res.data;
      });
    },
    getYearClick(){
      this.$http.get('yearClick',{params:{year:this.click.year}}).then((res)=>{
        self.click.yearValue = res.data;
      });
    },
    getMonthClick(){
      this.$http.get('monthClick',{params:{month:this.click.month}}).then((res)=>{
        self.click.monthValue = res.data;
      });
    },
    getClickLogs(){
      this.$http.get('listClickLogs',{params:{page:this.click.page}}).then((res)=>{
        self.click.logs = res.data;
      });
    },
    getLinkLogs(){
      this.$http.get('listLinkLogs',{params:{page:this.linkPage}}).then((res)=>{
        self.linkLogs = res.data;
      });
    },
    selectNav(nav){
      this.nav = nav;
      this.page = 1;
      if(nav == 0){
        this.getYearCommission();
        this.getMonthCommission();

        this.getYearClick();
        this.getMonthClick();
      }else{
        this.getCommissionLogs();
        this.getCommissionDateLogs();
        this.getClickLogs();
        this.getLinkLogs();
      }
      
    },

  }
}
</script>
<style>
.ant-spin-nested-loading.no-mask .ant-spin-blur{
  opacity: 0;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.nav-box{
  display: flex;
  margin-bottom: 40px;
}
.nav-box .item{
  position: relative;
  padding-right: 60px;
  cursor: pointer;
}
.nav-box .item:hover{
  color: rgba(255, 255, 255, 0.8);
}
.nav-box .item.active{
  color: #fff;
}
.nav-box .item.active::after{
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 30px;
  height: 2px;
  background: #fff;
}
  .logs-box{
    margin-top: 2rem;
  }
  .page-box{
    margin-top: 1rem;
    text-align: right;
    margin-bottom: 3rem;
  }
  .item-title{
    display: flex;
    color: #fff;

  }
  .item-title .left{
    flex: 1;
  }
  .item-title .right{
    flex: 1;
    text-align: right;
  }

  .count-box{
    padding: 2rem;
    margin: 1rem 0 3rem 0;
    border-radius: 10px;
    text-align: center;
    background: #26273b;
  }
  .count-box .value{
    font-size: 40px;
    font-family: cursive;
    color: #fff;
  }
  .count-box .label{
    font-size: 12px;
  }

  .transpanret-table{
    margin-top: 1rem;
  }
</style>
